import Config from "api/types/Config";

const requireJWT = (config: Config) => {
    if (!config.jwt) {
        throw new Error("This API call requires a JWT to be set");
    }
};

export default requireJWT;
